import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../../render/table/table-cell"

export default function FieldTaskLeadTime_TableCell(props:FieldTableCellProps) {

    const classes = Classes("cell-flex", {
        'ui5-txt-less-important-small'  : !props.listItem.task.isOpen,
        'ui5-txt-no-accent-small'       : props.listItem.task.isOpen,
    })

    const postfix = props.listItem.task.isOpen ? '+' : '';

    return (
        <div className={classes} style={getTableCellStyle(props)}>
            {props.field.getViewValue(props.listItem.task)}{postfix}
        </div>
    )
}

